export const EXAMPLE_PATH = "blog-starter";
export const CMS_NAME = "Markdown";
export const HOME_OG_IMAGE_URL = "/images/og-image.png";

// Role enums
export const ROLES = {
  OWNER: "owner",
  COLLABORATOR: "collaborator",
  PUBLIC_VIEWER: "public_viewer"
} as const;
